import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

import { isoDateTimeToLabel } from 'helpers/helpers';

import { AccountsStore } from 'stores/accountsStore';
import { MovementsStore } from 'stores/account/movementsStore';
import { AdvisorsStore } from 'stores/advisorsStore';
import { AdminCsvStore } from 'stores/admin/adminCsvStore';

interface Props {
  store: AccountsStore | AdvisorsStore | AdminCsvStore | MovementsStore;
}

const GenerationDialog: React.FC<Props> = ({ store }) => {
  const { t } = useTranslation();
  return (
    <Dialog open={store.generationDialog} maxWidth="sm">
      <DialogContent>
        <p>
          {t('backOffice_generationDate')}{' '}
          <strong>{isoDateTimeToLabel(store.generationDate!, 'dd. MM. yyyy HH:mm:ss')}</strong>
        </p>
        <p>{t(`backOffice_csvGenerationInfo${store.generationDrive ? 'Drive' : ''}`)}</p>
      </DialogContent>
      <DialogActions>
        <Button onClick={store.hideGenerationDialog} variant="contained" color="primary">
          {t('general_ok')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default observer(GenerationDialog);
